import {
    ROLE_ADD,
    ROLE_ITEM_DELETE_RESPONSE,
    ROLE_ITEM_SAVE_RESPONSE,
    ROLE_LIST_CACHED_RESPONSE,
    ROLE_LIST_RESPONSE,
    ROLE_REMOVE,
    STAKEHOLDER_ADD_NEW,
    STAKEHOLDER_CANCEL_MODEL_UPDATE,
    STAKEHOLDER_FINISH_SAVING,
    UNAUTHENTICATED
} from "../../actions/action-types"

const defaultState = {
    view: [],
    edit: []
}

export default (state = defaultState, action) => {
    const { type } = action
    switch (type) {
        case ROLE_LIST_RESPONSE:
            return {
                view: action.data.map(role => role.id),
                edit: action.data.map(role => role.id)
            }
        case ROLE_LIST_CACHED_RESPONSE:
            return {
                view: action.data,
                edit: action.data
            }
        case ROLE_ITEM_SAVE_RESPONSE:
            // if PATCH
            if (state.view.includes(action.item.id)) {
                return state
            } else {
                return {
                    ...state,
                    view: [action.item.id, ...state.view]
                }
            }
        case ROLE_ITEM_DELETE_RESPONSE:
            return {
                ...state,
                view: state.view.filter(role => role !== action.id)
            }
        case ROLE_ADD:
            return {
                ...state,
                edit: [action.role.id, ...state.edit]
            }
        case ROLE_REMOVE:
            return {
                ...state,
                edit: state.edit.filter(role => role !== action.roleID)
            }
        case STAKEHOLDER_CANCEL_MODEL_UPDATE:
            return {
                ...state,
                edit: [...state.view]
            }
        case STAKEHOLDER_ADD_NEW:
            return {
                view: [],
                edit: []
            }
        case STAKEHOLDER_FINISH_SAVING:
            return {
                ...state,
                edit: [...state.view]
            }
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
